export const adminDashboardTranslations = {
    en: {
        // Campaign Stats
        totalCamps: "Total Camps",
        ongoingCamps: "Ongoing Camps",
        completedCamps: "Completed Camps",
        approvedCamps: "Approved Camps",
        pendingCamps: "Pending Camps",
        upcomingCamps: "Upcoming Camps",
        rejectedCamps: "Rejected Camps",

        // Beneficiary Labels
        totalBeneficiary: "Total Beneficiary",
        preRegister: "Pre-Registration",
        register: "Registration",
        doctorScreening: "Doctor Screening",
        bloodTest: "Blood Test",
        stemi: "STEMI",
        hospitalRefer: "Hospital Refer",
        abhaCard: "ABHA Card",
        pharmacy: "Pharmacy",
        schemeRefer: "Scheme Refer",

        // Chart Titles
        beneficiaryAnalysis: "Beneficiary Analysis",
        totalBeneficiaries: "Total Beneficiaries",
        typeWiseHealthCampsCount: "Type-wise Health Camps Count",
        total: "Total",
        count: "Count",

        // Form Labels
        selectHealthCamp: "Select Health Camp",

        // Common
        unknown: "Unknown",
        unknownAddress: "Unknown Address",

        // Module Names
        beneficiaryAnalysisModule: "Beneficiary Analysis",
        typeWiseCampsModule: "Type-wise Health Camps Count",
    },
    mr: {
        // Campaign Stats
        totalCamps: "एकूण शिबिरे",
        ongoingCamps: "चालू शिबिरे",
        completedCamps: "पूर्ण शिबिरे",
        approvedCamps: "मंजूर शिबिरे",
        pendingCamps: "प्रलंबित शिबिरे",
        upcomingCamps: "आगामी शिबिरे",
        rejectedCamps: "नाकारलेली शिबिरे",

        // Beneficiary Labels
        totalBeneficiary: "एकूण लाभार्थी",
        preRegister: "पूर्व-नोंदणी",
        register: "नोंदणी",
        doctorScreening: "डॉक्टर तपासणी",
        bloodTest: "रक्त तपासणी",
        stemi: "STEMI",
        hospitalRefer: "रुग्णालय संदर्भ",
        abhaCard: "आभा कार्ड",
        pharmacy: "फार्मसी",
        schemeRefer: "योजना संदर्भ",

        // Chart Titles
        beneficiaryAnalysis: "लाभार्थी विश्लेषण",
        totalBeneficiaries: "एकूण लाभार्थी",
        typeWiseHealthCampsCount: "प्रकारानुसार आरोग्य शिबिरे संख्या",
        total: "एकूण",
        count: "संख्या",

        // Form Labels
        selectHealthCamp: "आरोग्य शिबिर निवडा",

        // Common
        unknown: "अज्ञात",
        unknownAddress: "अज्ञात पत्ता",

        // Module Names
        beneficiaryAnalysisModule: "लाभार्थी विश्लेषण",
        typeWiseCampsModule: "प्रकारानुसार आरोग्य शिबिरे संख्या",
    }
};
